module.exports = __webpack_public_path__ + "static/media/9.6c8d3299.png";